import { UrlProvider } from "../../Infrastructure/UrlProvider";
import { VersionNumber } from "./VersionNumber";

export class DownloadsStore {
    private _etag: string;
    private _downloads: Download[];
    private _initializer: Promise<Download[]>;
    static _instance = new DownloadsStore();
    static get instance() { 
        return this._instance;
    }

    constructor() { 
        this._initializer = this.doGetDownloads();
    }

    public hasNewverVewrsion = async (currentVersion: VersionNumber) => {
        await this._initializer;
        if (!this._downloads) {
            return false;
        }

        return this._downloads.some(download => download.versionNumber.isGreaterThan(currentVersion));
    }

    public async getDownloads() { 
        await this._initializer;
        return this._downloads;
    }

    private async doGetDownloads() { 
        try{
            const response = await fetch(`${UrlProvider.root}/api/downloads`, { 
                method: "get", 
                headers: {
                    "Content-Type": "application/json",
                    "If-None-Match": this._etag
                }
            });
            
            if (response.status === 304 || response.status === 204) {
                return this._downloads;
            }

            if (response.ok) { 
                let downloads = await response.json();

                downloads = this.decorateDownloads(downloads);
                downloads = this.sortByVersion(downloads);
                this._downloads = downloads;

                this._etag = response.headers.get("ETag");

                return this._downloads;
            }
        } catch(error){
            console.log(`Unable to log error. ${error}`)
        }
    }

    private decorateDownloads(downloads: Download[]): Download[] { 
        return downloads.map(download => {
            return {
                ...download,
                versionNumber: new VersionNumber(download.version)
            };
        });
    }

    private sortByVersion(downloads: Download[]): Download[] {
        return downloads.sort((a, b) => {
            if (a.versionNumber.isGreaterThan(b.versionNumber)) {
                return -1;
            } else if (a.versionNumber.isLessThan(b.versionNumber)) {
                return 1;
            } else {
                return 0;
            }
        });
    }
}


export interface Download { 
    created: string;
    description: string;
    path: string;
    version: string;
    versionNumber: VersionNumber;
}